<script lang="ts" setup></script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24">
    <path
      fill="currentColor"
      d="M12 2c-.5 0-1 .19-1.41.59l-8 8c-.79.78-.79 2.04 0 2.82l8 8c.78.79 2.04.79 2.82 0l8-8c.79-.78.79-2.04 0-2.82l-8-8C13 2.19 12.5 2 12 2m0 2l3.29 3.29l-3.29 3.3l-3.29-3.3zM7.29 8.71l3.3 3.29l-3.3 3.29L4 12zm9.42 0L20 12l-3.29 3.29l-3.3-3.29zM12 13.41l3.29 3.3L12 20l-3.29-3.29z"
    ></path>
  </svg>
</template>
